import React from 'react';
import { Typography } from 'antd';
import { Icon } from '@mdi/react';
import dayjs from 'dayjs';
import Ninja from '@ninja';
import { mdiAccountAlert, mdiCellphoneIphone, mdiGoogleChrome, mdiMicrosoftWindows } from '@mdi/js';
import useQueryParams from 'hooks/useQueryParams';

import TimeLineItem from './TimeLineItem';

const { Text } = Typography;

const SessionTimelineItem = ({ session, trigger = 'hover' }) => {
  const { setUrlParams, searchParams, removeParams } = useQueryParams();
  const { session_details_id } = searchParams;

  const { user, website, ip, os, device, url, browser } = session || {};

  const deviceTags = [
    os && {
      tooltip: 'Operating System',
      icon: <Icon path={mdiMicrosoftWindows} size={0.7} color={Ninja.colors.info} />,
      value: os,
    },
    device && {
      tooltip: 'Device',
      icon: <Icon path={mdiCellphoneIphone} size={0.7} color={Ninja.colors.info} />,
      value: device,
    },
    browser && {
      tooltip: 'Browser',
      icon: <Icon path={mdiGoogleChrome} size={0.7} color={Ninja.colors.info} />,
      value: browser,
    },
  ].filter(Boolean);

  const handleJourneyDetails = () => {
    setUrlParams({ session_details_id: session?.session_id });
    removeParams(['event_details_id']);
  };

  const active = session_details_id == session.session_id && session_details_id !== undefined;

  return {
    label: (
      <Text className='text-xs font-medium text-info'>
        {dayjs(session?.timestamp).format('MMM D, YYYY h:mm A')}
      </Text>
    ),
    children: (
      <TimeLineItem
        title='New Session'
        data={session}
        url={url}
        active={active}
        onClick={trigger !== 'hover' && handleJourneyDetails}
        trigger={trigger}
        type='session'
        deviceTagsList={deviceTags}
      />
    ),
    dot: <Icon path={mdiAccountAlert} size={0.8} color={Ninja.colors.orange} />,
  };
};

export default SessionTimelineItem;
